var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANTI_ALIASING_TECHNIQUE = exports.POST_PROCESSING_EFFECT_TYPE = void 0;
var POST_PROCESSING_EFFECT_TYPE;
(function (POST_PROCESSING_EFFECT_TYPE) {
  POST_PROCESSING_EFFECT_TYPE["BLOOM"] = "bloom";
  POST_PROCESSING_EFFECT_TYPE["CHROMATIC_ABERRATION"] = "chromatic_aberration";
  POST_PROCESSING_EFFECT_TYPE["DEPTH_OF_FIELD"] = "depth_of_field";
  POST_PROCESSING_EFFECT_TYPE["DOT_SCREEN"] = "dot_screen";
  POST_PROCESSING_EFFECT_TYPE["GOD_RAYS"] = "god_rays";
  POST_PROCESSING_EFFECT_TYPE["GRID"] = "grid";
  POST_PROCESSING_EFFECT_TYPE["HBAO"] = "hbao";
  POST_PROCESSING_EFFECT_TYPE["HUE_SATURATION"] = "hue_saturation";
  POST_PROCESSING_EFFECT_TYPE["NOISE"] = "noise";
  POST_PROCESSING_EFFECT_TYPE["OUTLINE"] = "outline";
  POST_PROCESSING_EFFECT_TYPE["PIXELATION"] = "pixelation";
  POST_PROCESSING_EFFECT_TYPE["SSAO"] = "ssao";
  POST_PROCESSING_EFFECT_TYPE["SCANLINE"] = "scanline";
  POST_PROCESSING_EFFECT_TYPE["SELECTIVE_BLOOM"] = "selective_bloom";
  POST_PROCESSING_EFFECT_TYPE["SEPIA"] = "sepia";
  POST_PROCESSING_EFFECT_TYPE["TILT_SHIFT"] = "tilt_shift";
  POST_PROCESSING_EFFECT_TYPE["VIGNETTE"] = "vignette";
})(POST_PROCESSING_EFFECT_TYPE = exports.POST_PROCESSING_EFFECT_TYPE || (exports.POST_PROCESSING_EFFECT_TYPE = {}));
var ANTI_ALIASING_TECHNIQUE;
(function (ANTI_ALIASING_TECHNIQUE) {
  ANTI_ALIASING_TECHNIQUE["FXAA"] = "fxaa";
  ANTI_ALIASING_TECHNIQUE["NONE"] = "none";
  ANTI_ALIASING_TECHNIQUE["SMAA"] = "smaa";
  ANTI_ALIASING_TECHNIQUE["SSAA"] = "ssaa";
})(ANTI_ALIASING_TECHNIQUE = exports.ANTI_ALIASING_TECHNIQUE || (exports.ANTI_ALIASING_TECHNIQUE = {}));
//# sourceMappingURL=IPostProcessingEffectDefinitions.js.map
export default exports;